import styled from 'styled-components'

export const ProgressContainer = styled.div`
  width: 100%;
  height: 1.25rem;
  border-radius: 1.25rem;
  background: #ddd;
  margin: 0;
  position: relative;
  overflow: hidden;
`

export const Progress = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  background: ${props => props.color};
  height: 100%;
  border-radius: 1.25rem;
`
